<template>
  <div>
  <!-- <div v-if="requestsLoaded"> -->
    <div v-if="!mobile" class="app flex flex-column">
      <Navigation />
      <div class="app-content flex flex-column">
        <Modal v-if="modalActive" />
        <transition name="request">
          <RequestModal v-if="requestModal" />
        </transition>
        <router-view />
      </div>
    </div>
        
    <div v-else class="mobile-message flex flex-column">
      <h2>Sorry, this app is not supported on Mobile Devices</h2>
      <p>To use this app, please use a computer or Tablet</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Navigation from './components/Navigation.vue'
import RequestModal from './components/RequestModal.vue'
import Modal from './components/Modal.vue'

export default {
  data() {
    return {
      mobile: null,
    };
  },
  components: {
    Navigation,
    RequestModal,
    Modal
  },
  created() {
    this.GET_REQUESTS();
    this.checkScreen();
    window.addEventListener("resize", this.checkScreen)
  },
  methods: {
    ...mapActions(["GET_REQUESTS"]),

    checkScreen() {
      const windowWidth = window.innerWidth;
      if (windowWidth <= 750) {
        this.mobile = true;
        return;
      }
      this.mobile = false;
    }
  },
  computed: {
    ...mapState([
      "requestModal", 
      "modalActive", 
      // "requestsLoaded"
    ]),
  },
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", monospace;
//   background-color: #141625;
}

.app {
    background-color: #141625;
    min-height: 100vh;
    @media (min-width: 900px) {
        flex-direction: row !important;
    }

    .app-content {
        padding: 0 20px;
        flex: 1;
        position: relative;
    }
}

.mobile-message {
    text-align: center;
    justify-content: center;
    align-items: center;
    height: 100hv;
    background-color: #141625;
    color: #fff;

    p {
        margin-top: 16px;
    }
}

// animated request
.request-enter-active,
.request-leave-active {
    transition: 0.8s ease all
}

.request-enter-from,
.request-leave-to {
    transform: translateX(-700px);
}


button,
.button {
  cursor: pointer;
  padding: 16px 24px;
  border-radius: 30px;
  border: none;
  font-size: 12px;
  margin-right: 8px;
  color: #fff;
}
button,
.button {
    color: #fff;
    border: none;
}

.dark-purple {
  background-color: #4c4d52;
}

.red {
  background-color: #ec5757;
}

.purple {
  background-color: #7c5dfa;
}

.blue {
  background-color: #536dfe;
}

.green {
  background-color: #33d69f;
}

.orange {
  background-color: #ff8f00;
}
// utility classes

.flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.container {
  width: 100%;
  padding: 40px 10px;
  max-width: 850px;
  margin: 0 auto;

  @media (min-width: 900px) {
    padding-top: 72px;
  }
}

.nav-link {
  text-decoration: none;
  color: initial;
}

// Status Button Styling

.status-button {
  &::before {
    content: "";
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 8px;
  }
  font-size: 12px;
  margin-right: 30px;
  align-items: center;
  padding: 8px 30px;
  border-radius: 10px;
}

.paid {
  &::before {
    background-color: #33d69f;
  }
  color: #33d69f;
  background-color: rgba(51, 214, 160, 0.1);
}

.pending {
  &::before {
    background-color: #ff8f00;
  }
  color: #ff8f00;
  background-color: rgba(255, 145, 0, 0.1);
}

.draft {
  &::before {
    background-color: #dfe3fa;
  }
  color: #dfe3fa;
  background-color: rgba(223, 227, 250, 0.1);
}
</style>